import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/jobs',
    name: 'Job',
    component: {
      name: 'AdminJob',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'job',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminJobIndex',
        component: () => import('../views/JobIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminJobNew',
        component: () => import('../views/JobInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminJobIndex' },
        },
      },
      {
        path: 'new/work_instruction_from_quotation',
        name: 'AdminWorkInstructionFromQuotationNew',
        component: () => import('../views/WorkInstructionFromQuotationInput.vue'),
        meta: {
          action: 'new',
          resource: 'work_instruction',
          backRoute: { name: 'AdminJobIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminJobShow',
        component: () => import('../views/JobShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminJobIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminJobDetails',
            component: () => import('../views/JobDetails.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminJobEdit',
            component: () => import('../views/JobInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminJobDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminJobAttachments',
            component: () => import('../views/attachment/JobAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminJobsIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminJobAttachmentsEdit',
            component: () => import('../views/attachment/JobAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminJobAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'phases',
            name: 'AdminJobPhases',
            component: () => import('../views/phase/JobPhases.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'planned_jobs',
            name: 'AdminJobPlannedJobs',
            component: () => import('../views/plannedJob/JobPlannedJobs.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'planned_job',
            },
          },
          {
            path: 'statistics',
            name: 'AdminJobStatistics',
            component: () => import('../views/statistics/JobStatistics.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'statistics',
            },
          },
          {
            path: 'work_orders',
            name: 'AdminJobWorkOrders',
            component: () => import('../views/workOrder/JobWorkOrders.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'work_order',
            },
          },
          {
            path: 'purchase_order',
            name: 'AdminJobPurchaseOrders',
            component: () => import('../views/purchaseOrder/JobPurchaseOrders.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'purchase_order',
            },
          },
          {
            path: 'logs',
            name: 'AdminJobLogs',
            component: () => import('../views/JobLogs.vue'),
            meta: {
              backRoute: { name: 'AdminJobIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));
